class CallCenterErrorService {
  constructor() {
    this.listeners = [];
    this.currentError = null;
  }

  subscribe(callback) {
    this.listeners.push(callback);
    return () => {
      this.listeners = this.listeners.filter((listener) => listener !== callback);
    };
  }

  showError(errorData) {
    this.currentError = errorData;
    this.listeners.forEach((listener) => listener(errorData));
  }

  showLeadSaveError(leadData, orgContact, error) {
    this.showError({
      errorType: 'LEAD_SAVE_FAILED',
      leadSummary: leadData,
      orgContact: orgContact,
      error: error,
      timestamp: new Date().toISOString()
    });
  }

  showSlotsFetchError(leadData, orgContact, error) {
    this.showError({
      errorType: 'SLOTS_FETCH_FAILED',
      leadSummary: leadData,
      orgContact: orgContact,
      error: error,
      timestamp: new Date().toISOString()
    });
  }

  showAppointmentSaveError(leadData, appointmentData, orgContact, error) {
    this.showError({
      errorType: 'APPOINTMENT_SAVE_FAILED',
      leadSummary: leadData,
      appointmentSummary: appointmentData,
      orgContact: orgContact,
      error: error,
      timestamp: new Date().toISOString()
    });
  }

  handleCrmUnavailableError(errorResponse) {
    if (errorResponse?.response?.data?.errorCode === 'CRM_UNAVAILABLE') {
      const data = errorResponse.response.data;
      this.showError({
        errorType: 'CRM_UNAVAILABLE',
        leadSummary: data.leadSummary,
        appointmentSummary: data.appointmentSummary,
        orgContact: data.orgContact,
        error: data.message,
        timestamp: new Date().toISOString()
      });
      return true;
    }
    return false;
  }

  clearError() {
    this.currentError = null;
    this.listeners.forEach((listener) => listener(null));
  }
}

const callCenterErrorService = new CallCenterErrorService();

export default callCenterErrorService;
